import $http from '../../../axios';

export async function getSales({commit}) {
    commit('setLoading', true);
    await $http.get('/api/reporte-presupuesto-de-ventas-clientes').then(async (response) => {
        await commit('setSales', response.data.data);
        commit('setLoading', false);
    });
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales_budget_by_contacts_warehouses/actions.js